module.exports = __webpack_public_path__ + "icon-php.2NZztTO4.svg";